var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import { connect } from "react-redux";
import { getTranslate, Translate } from "react-localize-redux";
import { SchemaElementTypes } from "../../interfaces/store/actions/payload/schema/schemaElements";
import { checkTranslation, parseTextUrls } from "../common";
import SchemaInstructionWrapper from "./SchemaInstructionWrapper";
import { storeEditorReferences } from "../../store/actions/schema";
import { InstructionType } from "../../interfaces/store/reducers/schema";
var SchemaInstructionsFactory = (function (_super) {
    __extends(SchemaInstructionsFactory, _super);
    function SchemaInstructionsFactory(props) {
        var _this = _super.call(this, props) || this;
        _this.getElementFieldReferences = _this.getElementFieldReferences.bind(_this);
        _this.createInstructions = _this.createInstructions.bind(_this);
        _this.createInstructionElements = _this.createInstructionElements.bind(_this);
        _this.collectMetadataReferences = _this.collectMetadataReferences.bind(_this);
        _this.parseReferences = _this.parseReferences.bind(_this);
        _this.createEditorInstructions = _this.createEditorInstructions.bind(_this);
        _this.parseEditorType = _this.parseEditorType.bind(_this);
        _this.getLocalizedText = _this.getLocalizedText.bind(_this);
        _this.generateInstructions = _this.generateInstructions.bind(_this);
        _this.generateLabel = _this.generateLabel.bind(_this);
        _this.addReferenceInstructions = _this.addReferenceInstructions.bind(_this);
        return _this;
    }
    SchemaInstructionsFactory.prototype.generateInstructions = function (instructions, key) {
        var _a = this.props, instructionElement = _a.instructionElement, parseUrls = _a.parseUrls, defaultInstructionClass = _a.defaultInstructionClass;
        var instructionNodes = [];
        instructions.forEach(function (instruction, index) {
            if (instruction) {
                var instructionContent = parseUrls ? parseTextUrls(instruction) : instruction;
                var instructionKey = key + "-" + index;
                instructionNodes.push(React.createElement(SchemaInstructionWrapper, { key: instructionKey, instructionElement: instructionElement, defaultClass: defaultInstructionClass, contentProps: {
                        value: instructionContent,
                    } }));
            }
        });
        return instructionNodes;
    };
    SchemaInstructionsFactory.prototype.generateLabel = function (label, key) {
        var _a = this.props, labelElement = _a.labelElement, translationPath = _a.translationPath, defaultLabelClass = _a.defaultLabelClass;
        var labelNode = label
            ? [label]
            : React.createElement(Translate, { id: translationPath + ".generalInstructions.text" });
        return (React.createElement(SchemaInstructionWrapper, { instructionElement: labelElement, defaultClass: defaultLabelClass, key: key, contentProps: {
                value: labelNode,
            } }));
    };
    SchemaInstructionsFactory.prototype.getElementFieldReferences = function (element) {
        var elementFieldReferences = [];
        switch (element.schemaType) {
            case SchemaElementTypes.SPAN_TYPE: {
                var _a = element, fieldReferences = _a.fieldReferences, tagReference = _a.tagReference;
                if (fieldReferences) {
                    elementFieldReferences = fieldReferences;
                }
                else if (tagReference) {
                    elementFieldReferences = [tagReference];
                }
                break;
            }
            case SchemaElementTypes.SEGMENT_TYPE:
                var spanReferences = element.spanReferences;
                elementFieldReferences = spanReferences;
                break;
            case SchemaElementTypes.COMPOSITE_FIELD_TYPE:
            case SchemaElementTypes.DECORATION_TYPE: {
                var fieldReferences = element.fieldReferences;
                elementFieldReferences = fieldReferences;
                break;
            }
            default:
                break;
        }
        return elementFieldReferences;
    };
    SchemaInstructionsFactory.prototype.getLocalizedText = function (text) {
        var translate = this.props.translate;
        var textLocalizationId = "_configurableManifoldDescriptions." + text + ".text";
        return checkTranslation(textLocalizationId, text, translate);
    };
    SchemaInstructionsFactory.prototype.createInstructionElements = function (instructionsConfig) {
        var label = instructionsConfig.label, description = instructionsConfig.description, key = instructionsConfig.key, displayLabel = instructionsConfig.displayLabel;
        var allInstructions = [];
        var localizedDescription = this.getLocalizedText(description);
        if (localizedDescription) {
            var instructions = localizedDescription.split("\n");
            if (displayLabel && label) {
                allInstructions.push(this.generateLabel(label, key));
            }
            allInstructions.push(this.generateInstructions(instructions, key));
        }
        return allInstructions;
    };
    SchemaInstructionsFactory.prototype.collectMetadataReferences = function (collection, spanReferences) {
        var collectionMetadataReferences = collection.metaDataReferences || [];
        var spanMetadataReferences = [];
        if (collection.refElements) {
            spanMetadataReferences = spanReferences.reduce(function (prev, cur) {
                var span = collection.refElements[cur];
                var metaDataReferences = span.metaDataReferences;
                var accumulated = prev.slice();
                if (metaDataReferences) {
                    accumulated = accumulated.concat(metaDataReferences);
                }
                return accumulated;
            }, []);
        }
        return collectionMetadataReferences.concat(spanMetadataReferences);
    };
    SchemaInstructionsFactory.prototype.parseReferences = function (referenceData) {
        var _this = this;
        var root = referenceData.root, references = referenceData.references;
        var instructions = [];
        if (root.refElements) {
            references.forEach(function (reference, index) {
                var element = root.refElements[reference];
                var label = element.label, description = element.description;
                var elementFieldReferences = _this.getElementFieldReferences(element);
                if (description) {
                    var itemKey = reference + "-" + index;
                    instructions.push(_this.createInstructionElements({
                        label: label,
                        description: description,
                        key: itemKey,
                        displayLabel: true,
                    }));
                }
                if (elementFieldReferences.length && element.refElements) {
                    instructions = instructions.concat(_this.parseReferences({
                        root: element,
                        references: elementFieldReferences,
                    }));
                }
            });
        }
        return instructions;
    };
    SchemaInstructionsFactory.prototype.createEditorInstructions = function (collectionElement) {
        var description = collectionElement.description, label = collectionElement.label;
        var instructions = [];
        if (description) {
            instructions = this.createInstructionElements({
                label: label,
                description: description,
                key: "collection-instructions",
                displayLabel: false,
            });
        }
        return instructions;
    };
    SchemaInstructionsFactory.prototype.addReferenceInstructions = function (allInstructions, referenceData, key) {
        var instructions = allInstructions.slice();
        var referenceInstructions = this.parseReferences(referenceData);
        instructions = instructions.concat(referenceInstructions);
        if (referenceInstructions.length > 0) {
            instructions.push(React.createElement("hr", { key: key + "-break" }));
        }
        return instructions;
    };
    SchemaInstructionsFactory.prototype.parseEditorType = function (editor) {
        var segmentReferences = editor.segmentReference
            ? [editor.segmentReference]
            : [];
        var relationReferences = editor.relationReference
            ? [editor.relationReference]
            : [];
        var spanReferences = editor.spanReferences || [];
        var metadataReferences = this.collectMetadataReferences(editor, spanReferences);
        var batchReferenceData = {
            root: editor,
            references: editor.batchFieldReferences || [],
        };
        var segmentReferenceData = {
            root: editor,
            references: segmentReferences,
        };
        var relationReferenceData = {
            root: editor,
            references: relationReferences,
        };
        var metaReferenceData = {
            root: editor,
            references: metadataReferences,
        };
        return {
            batchReferenceData: batchReferenceData,
            segmentReferenceData: segmentReferenceData,
            relationReferenceData: relationReferenceData,
            metaReferenceData: metaReferenceData,
        };
    };
    SchemaInstructionsFactory.prototype.createInstructions = function () {
        var instructions = [];
        var _a = this.props, editor = _a.editor, parsedEditorReferences = _a.parsedEditorReferences, schemaKey = _a.schemaKey;
        if (editor) {
            if (parsedEditorReferences) {
                var batchReferenceData = parsedEditorReferences.batchReferenceData, segmentReferenceData = parsedEditorReferences.segmentReferenceData, relationReferenceData = parsedEditorReferences.relationReferenceData, metaReferenceData = parsedEditorReferences.metaReferenceData;
                var editorInstructions = this.createEditorInstructions(editor);
                instructions = instructions.concat(editorInstructions);
                if (editorInstructions.length) {
                    instructions.push(React.createElement("hr", { key: "ci-break" }));
                }
                var BATCH = InstructionType.BATCH, SEGMENT = InstructionType.SEGMENT, RELATION = InstructionType.RELATION, METADATA = InstructionType.METADATA;
                instructions = this.addReferenceInstructions(instructions, batchReferenceData, BATCH);
                instructions = this.addReferenceInstructions(instructions, segmentReferenceData, SEGMENT);
                instructions = this.addReferenceInstructions(instructions, relationReferenceData, RELATION);
                instructions = this.addReferenceInstructions(instructions, metaReferenceData, METADATA);
            }
            else {
                this.props.storeEditorReferences({
                    schemaKey: schemaKey,
                    editorReferences: this.parseEditorType(editor),
                });
            }
        }
        return instructions;
    };
    SchemaInstructionsFactory.prototype.render = function () {
        return (React.createElement(React.Fragment, null, this.createInstructions()));
    };
    SchemaInstructionsFactory.defaultProps = {
        parseUrls: true,
        refInstructionLabel: true,
        editorInstructionLabel: false,
    };
    return SchemaInstructionsFactory;
}(React.Component));
function mapStateToProps(_a, _b) {
    var localize = _a.localize, instructions = _a.schema.instructions;
    var schemaKey = _b.schemaKey;
    var parsedEditorReferences = instructions[schemaKey];
    return {
        translate: getTranslate(localize),
        parsedEditorReferences: parsedEditorReferences,
    };
}
var mapDispatchToProps = {
    storeEditorReferences: storeEditorReferences,
};
export default connect(mapStateToProps, mapDispatchToProps)(SchemaInstructionsFactory);
